import { DateTime } from 'luxon';

export const getFormattedTime = (sessionStart, format) =>
    DateTime.fromMillis(Date.now() - sessionStart)
        .toUTC()
        .toFormat(format);
